import React from 'react';
import { BarChart2, MessageSquare, HelpCircle, Scissors, Music, Download } from 'lucide-react';
import './ToolShowcaseCarousel.css';

const TOOLS = [
    {
        id: 'clip',
        name: 'Smart Clips',
        icon: Scissors,
        description: 'Smart video clipping',
        media: `${process.env.PUBLIC_URL}/demos/clip-demo.mp4`,
        gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)'
    },
    {
        id: 'ranking',
        name: 'Ranked',
        icon: BarChart2,
        description: 'Create viral top-list videos',
        media: `${process.env.PUBLIC_URL}/demos/ranking-demo.mp4`,
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    },
    {
        id: 'downloader',
        name: 'Downloader',
        icon: Download,
        description: 'Download videos instantly',
        media: `${process.env.PUBLIC_URL}/demos/downloader-demo.mp4`,
        gradient: 'linear-gradient(135deg, #ff6a00 0%, #ee0979 100%)'
    },
    {
        id: 'quiz',
        name: 'Quizzes',
        icon: HelpCircle,
        description: 'Engaging quiz videos',
        media: `${process.env.PUBLIC_URL}/demos/quiz-demo.mp4`,
        gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
    },
    {
        id: 'rant',
        name: 'Rants',
        icon: MessageSquare,
        description: 'AI-powered rant videos',
        media: `${process.env.PUBLIC_URL}/demos/rant-demo.mp4`,
        gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
    },
    {
        id: 'audio',
        name: 'Audio Converter',
        icon: Music,
        description: 'Convert any audio format',
        media: `${process.env.PUBLIC_URL}/demos/converter-demo.mp4`,
        gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)'
    }
];

// Selected style: Punch Hole
const SELECTED_STYLE = 'style-punch';

const PhoneMockup = ({ tool }) => {
    const Icon = tool.icon;

    return (
        <div className={`phone-mockup ${SELECTED_STYLE}`}>
            <div className="phone-frame">
                <div className="phone-notch" />
                <div className="phone-screen" style={{ background: tool.gradient }}>
                    {tool.media ? (
                        (() => {
                            // Extract pathname without query params for extension check
                            const mediaPath = tool.media.split('?')[0];
                            const isVideo = mediaPath.endsWith('.mp4') || mediaPath.endsWith('.webm');
                            return isVideo ? (
                                <video
                                    src={tool.media}
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className="phone-video"
                                />
                            ) : (
                                <img src={tool.media} alt={tool.name} className="phone-image" />
                            );
                        })()
                    ) : (
                        <div className="phone-placeholder">
                            <Icon size={48} strokeWidth={1.5} />
                            <span className="placeholder-text">Demo Coming Soon</span>
                        </div>
                    )}
                </div>
            </div>
            <div className="phone-label">
                <Icon size={16} />
                <span>{tool.name}</span>
            </div>
        </div>
    );
};

export const ToolShowcaseCarousel = () => {
    return (
        <section className="tool-showcase-section">
            <div className="showcase-header-container">
                <h2 className="showcase-heading">Powerful Tools for Content Creators</h2>
                <p className="showcase-subheading">Create viral videos in minutes with our AI-powered suite</p>
            </div>

            <div className="carousel-container">
                {/* Three identical tracks for seamless infinite scroll on wide screens */}
                <div className="carousel-track-wrapper">
                    <div className="carousel-track">
                        {TOOLS.map((tool, index) => (
                            <PhoneMockup key={`a-${tool.id}-${index}`} tool={tool} />
                        ))}
                    </div>
                    <div className="carousel-track">
                        {TOOLS.map((tool, index) => (
                            <PhoneMockup key={`b-${tool.id}-${index}`} tool={tool} />
                        ))}
                    </div>
                    <div className="carousel-track">
                        {TOOLS.map((tool, index) => (
                            <PhoneMockup key={`c-${tool.id}-${index}`} tool={tool} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ToolShowcaseCarousel;
